import { render, staticRenderFns } from "./PersonIAAR.vue?vue&type=template&id=16a74d63&scoped=true&"
import script from "./PersonIAAR.vue?vue&type=script&lang=ts&"
export * from "./PersonIAAR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a74d63",
  null
  
)

export default component.exports